<script lang="ts" setup>
import { sdDialogProps } from './dialog'
import { useVModel     } from '@vueuse/core'
import { computed      } from 'vue'
import { dialogEmits, ElDialog, ElScrollbar, ElButton } from 'element-plus'

defineOptions({ name: 'SdDialog' })

const props = defineProps(sdDialogProps)
const emit   = defineEmits({
    ...dialogEmits,
    cancel : null,
    confirm: null
})

const dialogVisible   = useVModel(props, 'modelValue', emit)
const scrollbarStyle$ = computed(() => {
    return {
        height: typeof props.height === 'string' ? props.height : props.height + 'px'
    } 
})

// 点击取消按钮
const onClickCancel = () => {
    emit('cancel')
    dialogVisible.value = false
}

// 点击确认按钮
const onClickConfirm = () => {
    emit('confirm')
}
</script>

<template>
    <ElDialog
        v-model="dialogVisible"
        :title="props.title"
        :width="props.width"
        :fullscreen="props.fullscreen"
        :top="props.top"
        :modal="props.modal"
        :append-to-body="props.appendToBody"
        :lock-scroll="props.lockScroll"
        :custom-class="`sd-dialog ${props.customClass}`"
        :open-delay="props.openDelay"
        :close-delay="props.closeDelay"
        :close-on-click-modal="props.closeOnClickModal"
        :close-on-press-escape="props.closeOnPressEscape"
        :show-close="props.showClose"
        :before-close="props.beforeClose"
        :draggable="props.draggable"
        :center="props.center"
        :destroy-on-close="props.destroyOnClose"
        @open="$emit('open')"
        @opened="$emit('opened')"
        @close="$emit('close')"
        @closed="$emit('closed')"
        @open-auto-focus="$emit('openAutoFocus')"
        @close-auto-focus="$emit('closeAutoFocus')"
    >   
        <ElScrollbar :style="scrollbarStyle$">
            <div class="sd-dialog__body">
                <slot></slot>
            </div>
        </ElScrollbar>

        <template v-if="props.showFooter" #footer>
            <slot name="footer">
                <div class="sd-dialog__foot-left">
                    <slot name="foot-left"></slot>
                </div>
                <ElButton 
                    v-if="props.showCancelButton" 
                    large 
                    :disabled="props.submitting" 
                    @click="onClickCancel()"
                >
                    {{ props.cancelButtonText }}
                </ElButton>
                <ElButton 
                    v-if="props.showSubmitButton" 
                    large 
                    type="primary" 
                    :loading="props.submitting"
                    :disabled="props.submitting"
                    @click="onClickConfirm()"
                >
                    {{ props.submitButtonText }}
                </ElButton>
            </slot>
        </template>
    </ElDialog>
</template>
